

export class AppConfig {
    static allReward:number = 80640 *1e18;

    static get unlockIn() :Date{
        return new Date('2021/04/07 19:00 UTC+8');
    }
    static get unlockStaking() :Date{
        return new Date('2021/03/27 19:00 UTC+8');
    }

    // Premium
    static get  allTsl():allTslInterface{
        return {
            compound:4752000,
            aave:4088000,
            curve:3288000,
            sushiswap:3232000,
            yearn:218240,
            balancer:1408000,
            nexusMutual:221040,
            pickle:18587,
            keeperDAO:203176,
            boringDAO:61023,
        };
    };
    /*// tsl
    static get  allPremium():allTslInterface{
        return {
            compound:1304000,
            aave:1176000,
            curve:725840,
            sushiswap:623040,
            yearn:358400,
            balancer:310720,
            nexusMutual:76080,
            pickle:24350,
            keeperDAO:84240,
            boringDAO:18849,
        };
    };*/
    static get  allRAF():allTslInterface{
        return {
            compound:0.1,
            aave:0.1,
            curve:.1,
            sushiswap:.1,
            yearn:.6,
            balancer:.6,
            nexusMutual:.6,
            pickle:3,
            keeperDAO:3,
            boringDAO:3,
        };
    };
}


export interface allTslInterface {
    compound:number,
    aave:number,
    curve:number,
    yearn:number,
    balancer:number,
    sushiswap:number,
    nexusMutual:number,
    pickle:number,
    keeperDAO:number,
    boringDAO:number
}
